import styled from "styled-components";

const PostQueriesSc = styled.div`
  margin: 10px;
  padding: 5px;
  height: 90vh;
  border-radius: 10px;
  /* fallback for old browsers */
  width: 100vw;
  /* Chrome 10-25, Safari 5.1-6 */
  position: absolute;
  top: 45px;
  display: flex;
  flex-direction: column;
  .queries-container {
    width: 90vw;
    height: 90vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .queries-container > div {
    width: 50%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
`;
export default PostQueriesSc;
